import React from "react";

import PaymentResult from "./PaymentResult";

const Success = (props) => <PaymentResult outcome="success" location={props.location} />;

export default Success;
